function checkOneOf(value, possibleValues, error) {
    if (!possibleValues.includes(value))
        throw new Error(error);
}

export { checkOneOf as c };
